module.exports = __webpack_public_path__ + "static/habStill8-ca72ec6a445105f908113218cf95ee42.png";